export default __webpack_public_path__ + "static/badge-new-e947d0f73f34be84b3636e2ce6b2bb22.svg";